/* @flow */
export default {
  FIRST_NAME_LENGTH: 40,
  LAST_NAME_LENGTH: 80,
  ORGANIZATION_NAME_LENGTH: 255,
};
